import { render } from "./CertificatesGallery.vue?vue&type=template&id=2e00691e&scoped=true"
import script from "./CertificatesGallery.vue?vue&type=script&lang=js"
export * from "./CertificatesGallery.vue?vue&type=script&lang=js"

import "./CertificatesGallery.vue?vue&type=style&index=0&id=2e00691e&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e00691e"]])

export default __exports__